var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 3.33333C2.30185 3.33333 2.00033 3.63486 2.00033 4V12C2.00033 12.3651 2.30185 12.6667 2.66699 12.6667H13.3337C13.6988 12.6667 14.0003 12.3651 14.0003 12V4C14.0003 3.63486 13.6988 3.33333 13.3337 3.33333H2.66699ZM0.666992 4C0.666992 2.89848 1.56547 2 2.66699 2H13.3337C14.4352 2 15.3337 2.89848 15.3337 4V12C15.3337 13.1015 14.4352 14 13.3337 14H2.66699C1.56547 14 0.666992 13.1015 0.666992 12V4Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787561 3.61769C0.998704 3.31606 1.41439 3.2427 1.71602 3.45384L8.00038 7.85289L14.2847 3.45384C14.5864 3.2427 15.0021 3.31606 15.2132 3.61769C15.4243 3.91932 15.351 4.33501 15.0494 4.54615L8.38269 9.21282C8.15314 9.3735 7.84762 9.3735 7.61807 9.21282L0.951408 4.54615C0.649775 4.33501 0.576419 3.91932 0.787561 3.61769Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b6c8b05dc3af5a4b9878c3612346d8ad.svg";
export { ForwardRef as ReactComponent };